export default "__VITE_ASSET__ybd72rkX__"